import { useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { api, errMsg, useApi } from "../lib/api";
import { PageHeader } from "../components/Layout";
import { ConfirmDialog } from "../components/Common";
import { ChampionBanner, SeasonClock, SeasonHistory } from "../components/SeasonBits";
import { Button } from "../components/ui/button";

export default function SeasonsPage() {
  const current = useApi("/seasons/current", 30000);
  const history = useApi("/seasons");
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);

  const closeNow = async () => {
    setConfirm(false);
    setBusy(true);
    try {
      const { data } = await api.post("/admin/seasons/close");
      const champ = data.closed.champion ? `Campeã: ${data.closed.champion.label}` : "Sem campeã";
      toast.success(`Temporada #${data.closed.number} fechada. ${champ}.`);
      current.reload();
      history.reload();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Competição semanal" title="Temporadas">
        <Button onClick={() => setConfirm(true)} disabled={busy} className="bg-rose-600 text-white hover:bg-rose-500" data-testid="close-season-button">
          <Flag className="mr-2 h-4 w-4" />Fechar temporada agora
        </Button>
      </PageHeader>
      <div className="mb-8 flex flex-wrap items-start gap-6">
        <SeasonClock season={current.data} />
        <p className="max-w-md text-sm text-slate-400">
          As temporadas fecham automaticamente todos os domingos às 18:00 (hora de Lisboa). Ao fechar: guerras ativas são canceladas,
          a classificação é guardada, pontos e zonas são repostos e começa uma nova temporada.
        </p>
      </div>
      <ChampionBanner season={current.data} />
      <h2 className="mb-4 text-lg font-semibold uppercase tracking-wider">Histórico</h2>
      <SeasonHistory seasons={history.data} />
      <ConfirmDialog open={confirm} onOpenChange={setConfirm} testid="close-season-dialog" title="Fechar temporada agora?"
        confirmLabel="Fechar temporada" onConfirm={closeNow}
        description={`A temporada #${current.data?.number ?? ""} será fechada: todas as guerras ativas serão canceladas e os pontos, vitórias, derrotas, kills, zonas e cooldowns de todas as organizações serão repostos a zero.`} />
    </div>
  );
}
